import secureLocalStorage from 'react-secure-storage'

export const saveLocalStorage = (key: string, value: any) => {
  secureLocalStorage.setItem(key, JSON.stringify(value))
}

export const getLocalStorage = (key: string) => {
  const value = secureLocalStorage.getItem(key)
  if (value) {
    return JSON.parse(value as string)
  }
  return null
}

// Utility to safely parse JSON with fallback
export const safeJsonParse = <T = any>(value: string | null, fallback: T): T => {
  if (!value) return fallback
  try {
    return JSON.parse(value) as T
  } catch {
    console.error('Failed to parse JSON:', value)
    return fallback
  }
}

// Check if user is VIP and not expired
export const isVipActive = (authData: { vipStatus: number; expTime: string } | null): boolean => {
  if (!authData) return false
  if (authData.vipStatus === 0) return false

  // Use dayjs if available, otherwise use Date
  try {
    const expTime = new Date(authData.expTime)
    return expTime.getTime() > Date.now()
  } catch {
    return false
  }
}
